module.exports = __webpack_public_path__ + "img/ama_long@2x.0b88a360.png";